document.addEventListener('DOMContentLoaded', function () {

  // Blokkeer de Palo Alto search popdown via MutationObserver
  const popdown = document.querySelector('[data-popdown-body]');
  if (popdown) {
    const observer = new MutationObserver(function () {
      const details = document.querySelector('details:has(summary.search-popdown__toggle)');
      if (details && details.hasAttribute('open')) {
        details.removeAttribute('open');
      }
    });
    observer.observe(document.body, { attributes: true, subtree: true });
  }

  // Blokkeer form submit
  document.querySelectorAll('form[action*="/search"]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }, true);
  });

});